module.exports = __webpack_public_path__ + "img/1AAA级信用企业.8f5f840d.jpg";